export interface PricePresentation {
  /*                                             */
  showUvp: boolean
  /*                               */
  strikethrough: boolean
  /*                                     */
  redRetailPrice: boolean
}

export interface PriceInputs {
  retailPrice: number
  suggestedRetailPrice?: number
  saleFlag: boolean
}

export function hasValidSuggestedRetailPrice(p: PriceInputs): boolean {
  return typeof p.suggestedRetailPrice === 'number' && p.suggestedRetailPrice > p.retailPrice;
}

/**
 *
 *
 *
 */
export function statusQuoPricePresentation(p: PriceInputs): PricePresentation {
  const hasSuggestedRetailPrice = p.suggestedRetailPrice != null;
  return {
    showUvp: p.saleFlag && hasSuggestedRetailPrice,
    strikethrough: p.saleFlag && hasSuggestedRetailPrice,
    redRetailPrice: p.saleFlag,
  };
}
